import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { SelectChipOptionContainer } from "~/components/Select/components/SelectChipOptionContainer";
import { Select } from "~/components/Select/Select";
import { UploaderChip } from "~/components/Selects/Uploader/UploaderChip";
import { convertUploaderToOption } from "~/components/Selects/Uploader/utils";
import { UPLOADER_SELECT } from "~/constants/testIDs";
export const UploaderSelect = /*#__PURE__*/ memo((param)=>{
    let { uploaders, selectedUploaders, onUploaderSelectionChange, placeholder = "Search workspace members", ...props } = param;
    const options = useMemo(()=>uploaders.map((u)=>convertUploaderToOption(u)), [
        uploaders
    ]);
    const selectedOptions = useMemo(()=>selectedUploaders.map((u)=>convertUploaderToOption(u)), [
        selectedUploaders
    ]);
    const onSelectionChange = useCallback((param)=>{
        let { chips } = param;
        onUploaderSelectionChange(chips);
    }, [
        onUploaderSelectionChange
    ]);
    const onUploaderDeselect = useCallback((uploader)=>{
        onUploaderSelectionChange(selectedUploaders.filter((u)=>u.id !== uploader.id));
    }, [
        onUploaderSelectionChange,
        selectedUploaders
    ]);
    const listItemRenderer = useCallback((uploader)=>/*#__PURE__*/ _jsx(SelectChipOptionContainer, {
            className: "-mx-0.5 py-2",
            children: /*#__PURE__*/ _jsx(UploaderChip, {
                uploader: uploader,
                className: "bg-transparent"
            })
        }), []);
    const selectedItemRenderer = useCallback((uploader)=>/*#__PURE__*/ _jsx(UploaderChip, {
            uploader: uploader,
            className: "m-0.5",
            onRemoveUploader: onUploaderDeselect
        }), [
        onUploaderDeselect
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        "data-testid": UPLOADER_SELECT,
        options: options,
        maxDropdownHeight: 300,
        onSelectionChange: onSelectionChange,
        selectedOptions: selectedOptions,
        renderAsInput: true,
        isSearchable: true,
        isSticky: true,
        placeholder: placeholder,
        chipRenderer: selectedItemRenderer,
        listItemRenderer: listItemRenderer,
        ...props
    });
});
UploaderSelect.displayName = "UploaderSelect";
